import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";

import ValueProp, { IValuePropData } from "../ValueProp";

import styles from "./index.module.scss";

type IProps = Immutable<{
    valueProps: ReadonlyArray<IValuePropData>;
    className?: string;
}>;

export const ValuePropsBar = (props: IProps): React.ReactNode => {
    const containerClasses = classNames(styles.container, props.className);
    const rootClasses = classNames(styles.root, props.className);

    return (
        <div className={containerClasses}>
            <ul className={rootClasses}>
                {props.valueProps.map((valueProp, i) => (
                    <ValueProp
                        key={i}
                        prop={valueProp}
                        className={props.className || ""}
                    />
                ))}
            </ul>
        </div>
    );
};
